import { RCTimestamp } from '../types/rocketchat.types';

export function parseTs(ts: RCTimestamp | undefined | null): Date | null {
  if (!ts) return null;
  if (typeof ts === 'object' && '$date' in ts) return new Date(ts.$date);
  const d = new Date(ts as string);
  return isNaN(d.getTime()) ? null : d;
}
